// extracted by mini-css-extract-plugin
module.exports = {"drawerCollapsed":"style_drawerCollapsed__1a-eo","drawerExpanded":"style_drawerExpanded__3DtW5"};